import { render } from "./index.vue?vue&type=template&id=5c0a5f9a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5c0a5f9a&lang=scss&scoped=true"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0a5f9a"]])

export default __exports__